module.exports = "<div id=\"mark\">\n  <h2>{{$route.params.id === 0 ? 'Add' : 'Edit'}} Grade</h2>\n  <form novalidate @submit.stop.prevent=\"submit\" v-if=\"markForm\">\n    <md-input-container>\n      <label>Grade</label>\n      <md-input type=\"number\" v-model=\"markForm.mark\"></md-input>\n    </md-input-container>\n\n    <md-input-container>\n      <label>Weighting</label>\n      <md-input type=\"number\" v-model=\"markForm.weighting\"></md-input>\n    </md-input-container>\n\n    <md-button class=\"md-raised md-primary\" type=\"submit\">Submit</md-button>\n  </form>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/mark/mark.html
// module id = 106
// module chunks = 1